import React from 'react';
import './Modal.css';

/**
 * Modal de confirmation
 * Props: title, message, confirmLabel, confirmVariant ('danger'|'primary'), onConfirm, onCancel
 */
export function ConfirmModal({ title, message, confirmLabel = 'Confirmer', confirmVariant = 'danger', onConfirm, onCancel }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className={`modal-icon-wrap modal-icon-${confirmVariant}`}>
          <i className={`fa-solid ${confirmVariant === 'danger' ? 'fa-triangle-exclamation' : 'fa-circle-question'}`} />
        </div>
        <h3 className="modal-title">{title}</h3>
        {message && <p className="modal-message">{message}</p>}
        <div className="modal-actions">
          <button className="btn-secondary modal-btn" onClick={onCancel}>
            <i className="fa-solid fa-xmark" /> Annuler
          </button>
          <button className={`modal-btn modal-btn-${confirmVariant}`} onClick={onConfirm}>
            <i className={`fa-solid ${confirmVariant === 'danger' ? 'fa-user-xmark' : 'fa-check'}`} /> {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * Modal d'erreur / info
 * Props: title, message, onClose
 */
export function AlertModal({ title, message, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon-wrap modal-icon-danger">
          <i className="fa-solid fa-circle-exclamation" />
        </div>
        <h3 className="modal-title">{title || 'Erreur'}</h3>
        {message && <p className="modal-message">{message}</p>}
        <div className="modal-actions">
          <button className="btn-primary modal-btn" onClick={onClose}>
            <i className="fa-solid fa-check" /> OK
          </button>
        </div>
      </div>
    </div>
  );
}
